/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomListSchema,
    InternalApiCustomListSchemaFromJSON,
    InternalApiCustomListSchemaToJSON,
    InternalApiEntityOrder,
    InternalApiEntityOrderFromJSON,
    InternalApiEntityOrderToJSON,
} from '../models';

export interface CreateCustomListSchemaRequest {
    customListId: string;
    internalApiCustomListSchema: InternalApiCustomListSchema;
}

export interface GetCustomListSchemaRequest {
    customListId: string;
}

export interface GetListHistoricSchemaRequest {
    customListId: string;
    schemaId: number;
}

export interface SortCustomListSchemaRequest {
    customListId: string;
    internalApiEntityOrder: Array<InternalApiEntityOrder>;
}

export interface UpdateCustomListSchemaRequest {
    customListId: string;
    internalApiCustomListSchema: InternalApiCustomListSchema;
}

/**
 * 
 */
export class CustomListSchemaApi extends runtime.BaseAPI {

    /**
     * Creates custom list schema
     */
    async createCustomListSchemaRaw(requestParameters: CreateCustomListSchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSchema>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling createCustomListSchema.');
        }

        if (requestParameters.internalApiCustomListSchema === null || requestParameters.internalApiCustomListSchema === undefined) {
            throw new runtime.RequiredError('internalApiCustomListSchema','Required parameter requestParameters.internalApiCustomListSchema was null or undefined when calling createCustomListSchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/custom-lists/{customListId}/schema`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListSchemaToJSON(requestParameters.internalApiCustomListSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSchemaFromJSON(jsonValue));
    }

    /**
     * Creates custom list schema
     */
    async createCustomListSchema(requestParameters: CreateCustomListSchemaRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSchema> {
        const response = await this.createCustomListSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets Custom list Schema
     */
    async getCustomListSchemaRaw(requestParameters: GetCustomListSchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSchema>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getCustomListSchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/custom-lists/{customListId}/schema`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSchemaFromJSON(jsonValue));
    }

    /**
     * Gets Custom list Schema
     */
    async getCustomListSchema(requestParameters: GetCustomListSchemaRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSchema> {
        const response = await this.getCustomListSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get record schema
     */
    async getListHistoricSchemaRaw(requestParameters: GetListHistoricSchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSchema>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getListHistoricSchema.');
        }

        if (requestParameters.schemaId === null || requestParameters.schemaId === undefined) {
            throw new runtime.RequiredError('schemaId','Required parameter requestParameters.schemaId was null or undefined when calling getListHistoricSchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/historic-schema/{schemaId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"schemaId"}}`, encodeURIComponent(String(requestParameters.schemaId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSchemaFromJSON(jsonValue));
    }

    /**
     * Get record schema
     */
    async getListHistoricSchema(requestParameters: GetListHistoricSchemaRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSchema> {
        const response = await this.getListHistoricSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates custom list schema sort order
     */
    async sortCustomListSchemaRaw(requestParameters: SortCustomListSchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSchema>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling sortCustomListSchema.');
        }

        if (requestParameters.internalApiEntityOrder === null || requestParameters.internalApiEntityOrder === undefined) {
            throw new runtime.RequiredError('internalApiEntityOrder','Required parameter requestParameters.internalApiEntityOrder was null or undefined when calling sortCustomListSchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/custom-lists/{customListId}/schema/sort-order`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.internalApiEntityOrder.map(InternalApiEntityOrderToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSchemaFromJSON(jsonValue));
    }

    /**
     * Updates custom list schema sort order
     */
    async sortCustomListSchema(requestParameters: SortCustomListSchemaRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSchema> {
        const response = await this.sortCustomListSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates custom list schema
     */
    async updateCustomListSchemaRaw(requestParameters: UpdateCustomListSchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSchema>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling updateCustomListSchema.');
        }

        if (requestParameters.internalApiCustomListSchema === null || requestParameters.internalApiCustomListSchema === undefined) {
            throw new runtime.RequiredError('internalApiCustomListSchema','Required parameter requestParameters.internalApiCustomListSchema was null or undefined when calling updateCustomListSchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/custom-lists/{customListId}/schema`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListSchemaToJSON(requestParameters.internalApiCustomListSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSchemaFromJSON(jsonValue));
    }

    /**
     * Updates custom list schema
     */
    async updateCustomListSchema(requestParameters: UpdateCustomListSchemaRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSchema> {
        const response = await this.updateCustomListSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
